import { render, staticRenderFns } from "./SimpleField.vue?vue&type=template&id=3808f29a&scoped=true"
import script from "./SimpleField.vue?vue&type=script&lang=js"
export * from "./SimpleField.vue?vue&type=script&lang=js"
import style0 from "./SimpleField.vue?vue&type=style&index=0&id=3808f29a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../common/temp/node_modules/.pnpm/vue-loader@15.11.1_qty7iymlffgpukvncpluvycwfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3808f29a",
  null
  
)

export default component.exports